import Papa from 'papaparse';

export interface ParsedCsvResult {
  data: Record<string, string>[];
  errors: Papa.ParseError[];
  meta: Papa.ParseMeta;
}

export function parseCsvFile(file: File): Promise<ParsedCsvResult> {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      transformHeader: (header: string) => header.trim(),
      transform: (value: string) => value.trim(),
      complete: (results) => {
        resolve({
          data: results.data as Record<string, string>[],
          errors: results.errors,
          meta: results.meta,
        });
      },
      error: (error: any) => reject(error),
    });
  });
}



